export default __webpack_public_path__ + "static/media/questionMark.f5d495d8.png";